import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AuthScreen } from "@/components/auth/auth-screen";
import { ChoosePasswordForm } from "@/components/auth/choose-password-form";
import { useAdminPassword } from "@/hooks/use-admin-password";

const SetPasswordPage = () => {
  const { email, token } = Route.useSearch();
  const mutation = useAdminPassword().setPassword();

  return (
    <AuthScreen title="Set your password">
      <p className="pb-6 text-sm text-content-muted">
        Choose a password to finish setting up your EO admin account.
      </p>

      <ChoosePasswordForm
        email={email}
        mutation={mutation}
        submitLabel="Set password"
        successMessage="Your password is set. You can log in now."
        token={token}
      />
    </AuthScreen>
  );
};

export const Route = createFileRoute("/_guest/set-password/")({
  component: SetPasswordPage,
  validateSearch: z.object({
    token: z.string().catch(""),
    email: z.string().catch(""),
  }),
});
